// ** Redux Imports
import { createSlice } from '@reduxjs/toolkit'

export const authSlice = createSlice({
  name: 'authentication',
  initialState: {
    definition: null
  },
  reducers: {
    loadDefinition: (state, action) => {
      state.definition = action.payload
    }
  }
})

export const { loadDefinition } = authSlice.actions

export default authSlice.reducer
